import { Component } from '@angular/core';

@Component({
  selector: 'app-collapsible',
  templateUrl: './collapsible.component.html',
  styleUrls: ['./collapsible.component.scss']
})
export class CollapsibleComponent {
  isOpen: boolean = false;

  toggleCollapsible() {
    this.isOpen = !this.isOpen;
  }
}
